import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { theme } from "src/assets/theme";
import { usePatient } from "src/context/PatientProvider";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";

const Subheader = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "payment-information";
  const language = usePatient((patient) => patient.profile.language);
  const productSlug = useProduct((p) => p.slug);

  const subHeader = useMemo(() => {
    if (["b-ot", "ec", "db-ot"].includes(productSlug)) {
      return t(`${page}.${productSlug}.subheader`);
    }

    const string = t(`${page}.subheader`);

    const phraseToStyle =
      language === "en" ? "you’ll achieve" : "puedes lograr";
    const parts = string.split(new RegExp(`(${phraseToStyle})`, "i"));

    return (
      <>
        {parts.map((part, index) =>
          part.toLowerCase() === phraseToStyle.toLowerCase() ? (
            <Typography
              key={index}
              component="span"
              color={theme.palette.primary.main}
              sx={{ textDecoration: "underline" }}
              variant={isMobile ? "body1" : "h6"}
              fontWeight={600}
            >
              {part}
            </Typography>
          ) : (
            part
          ),
        )}
      </>
    );
  }, [isMobile, language, productSlug, t]);

  return <>{subHeader}</>;
};

export default Subheader;
